/**
 * Service worker registration — runs once at app boot.
 *
 * Disabled in dev to avoid hot-reload races with webpack-dev-server's own
 * service-worker behavior.
 *
 * iter205 (May 28 2026, v2) — earlier we tried auto-reloading on
 * `sw-updated` / `controllerchange` to push new admin code to existing
 * tabs. That caused an infinite reload loop on /config/login. Removed.
 *
 * New approach: rely on the SW's natural cache-bust on activate (when
 * VERSION constant in sw.js bumps). Old cached chunks get purged. The
 * user does ONE manual refresh after a new deploy and everything works.
 */

const isProd =
    process.env.NODE_ENV === "production" ||
    (typeof window !== "undefined" &&
        window.location.hostname !== "localhost" &&
        window.location.hostname !== "127.0.0.1");

export function registerServiceWorker() {
    if (typeof window === "undefined") return;
    if (!("serviceWorker" in navigator)) return;
    if (!isProd) return; // dev → skip to avoid HMR conflicts

    window.addEventListener("load", () => {
        navigator.serviceWorker
            .register("/sw.js")
            .then((reg) => {
                // When the browser detects a new SW (different content
                // hash from /sw.js), it queues the new SW for install.
                // We don't force-update or auto-reload — the SW's own
                // install handler calls self.skipWaiting() so the new
                // version takes effect on the user's next navigation.
                reg.addEventListener("updatefound", () => {
                    const installing = reg.installing;
                    if (!installing) return;
                    installing.addEventListener("statechange", () => {
                        if (installing.state === "installed" && navigator.serviceWorker.controller) {
                            // Politely ask the waiting SW to skip waiting
                            // — but DO NOT reload the page. The new SW
                            // will control the NEXT navigation naturally.
                            try { installing.postMessage("skip-waiting"); } catch { /* noop */ }
                        }
                    });
                });
            })
            .catch(() => { /* fail silently — SW is a progressive enhancement */ });
    });
}
